var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-grid-1-col gutter-md" }, [
    _c("div", { staticClass: "input card-holder" }, [
      _c("input", {
        staticClass: "req",
        attrs: {
          type: "text",
          id: "card-holder",
          name: "CardHolderName",
          value: "Jhon Doe",
          "data-val-required": "Card holder name is required.",
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "floating req is-active",
          attrs: { for: "card-holder" },
        },
        [_vm._v(_vm._s(_vm.tc("formFields.cardHolder")))]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input card-number" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "floating req is-active",
          attrs: { for: "card-number" },
        },
        [_vm._v(_vm._s(_vm.tc("formFields.cardNumber")))]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input card-exp" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "floating req is-active", attrs: { for: "card-exp" } },
        [_vm._v(_vm._s(_vm.tc("formFields.cardExpirationDate")))]
      ),
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "This credit card form is intended for the local environment only. VGS form for the local environment is disabled."
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "card-number" } }, [
      _c("input", {
        staticClass: "req",
        attrs: {
          type: "text",
          id: "card-number",
          name: "CardNumber",
          value: "4111111111111111",
          maxlength: "16",
          "data-val-required": "Card number is required.",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "card-exp" } }, [
      _c("input", {
        staticClass: "req",
        attrs: {
          type: "text",
          id: "card-exp",
          name: "CardExpirateDate",
          value: "12/26",
          "data-val-required": "Exp data is required.",
          maxlength: "5",
          pattern: "\\d{4}",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input card-code" }, [
      _c("div", { attrs: { id: "card-code" } }, [
        _c("input", {
          staticClass: "req",
          attrs: {
            type: "text",
            id: "card-code",
            name: "cardCode",
            value: "VI",
            "data-val-required": "Exp data is required.",
            pattern: "\\d{4}",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "floating req is-active", attrs: { for: "card-exp" } },
        [_vm._v("Card Code")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }